export const CA_DATE_FORMAT = [
	'MM/dd/yyyy',
	'M/d/yyyy',
	'MM/dd/yy',
	'M/d/yy',
	'MM-dd-yyyy',
	'M-d-yyyy',
	'MM-dd-yy',
	'M-d-yy',
	'yyyy-MM-dd',
	'yyyy/MM/dd',
	'yy/M/d',
	'yy/MM/dd',
	'yyyy-MM-dd',
	'yy-MM-dd',
]

export const CA_DATE_FORMAT_DEFAULT = 'MM/dd/yyyy'

export const CA_INVALID_KEYS = [
	'+',
	'.',
	'ArrowUp',
	'ArrowDown',
]

export const CA_TIMEOUT_DEFAULT = 2000

export const CA_VALID_DATE_INPUT_KEYS = [
	'-',
	'/',
	'0',
	'1',
	'2',
	'3',
	'4',
	'5',
	'6',
	'7',
	'8',
	'9',
	'Backspace',
	'Delete',
	'Enter',
	'Escape',
	'Tab',
	'ArrowUp',
	'ArrowDown',
	'ArrowLeft',
	'ArrowRight',
]

export const CA_VALID_INPUT_KEYS = [
	'-',
	'0',
	'1',
	'2',
	'3',
	'4',
	'5',
	'6',
	'7',
	'8',
	'9',
	'Backspace',
	'Delete',
	'Enter',
	'Escape',
	'Tab',
]
